<template>
  <div class="maintain-aspect-ratio">
    <div class="maintain-aspect-ratio-wrapper" :style="{ paddingTop: `${100 / width * height}%`}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'maintain-aspect-ratio',
  props: {
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 9,
    },
  },
};
</script>

<style lang="scss">
// FF and Edge handle `padding-top` percentages differently on flexbox elements
// so we need to add an extra wrapper div and force the element to block
// see: https://stackoverflow.com/questions/34358919/flex-box-and-responsive-aspect-ratio-issue-in-firefox
.maintain-aspect-ratio {
  display: block !important; // required for FF
  position: relative;

  > .maintain-aspect-ratio-wrapper { // required for FF
    > * {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utility/MaintainAspectRatio.vue